var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "tasks" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 45, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "任务名称", "label-width": 70 } },
                        [
                          _c("el-input", {
                            staticStyle: { "min-width": "300px" },
                            attrs: { maxlength: 100, clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "学校", prop: "schoolId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "min-width": "300px" },
                              attrs: {
                                placeholder: "学校名称",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              on: { change: _vm.changeSchool },
                              model: {
                                value: _vm.search.schoolId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "schoolId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.schoolId",
                              },
                            },
                            _vm._l(_vm.schoolsList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { "min-width": "300px" },
                                attrs: { label: item.label, value: item.value },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleShoolChange(item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检日期", "label-width": 75 } },
                        [
                          _c("DatePicker", {
                            staticStyle: { width: "112px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "起始日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changestart },
                            model: {
                              value: _vm.search.startPhysicalDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "startPhysicalDate", $$v)
                              },
                              expression: "search.startPhysicalDate",
                            },
                          }),
                          _c("DatePicker", {
                            staticStyle: { width: "112px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "结束日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeend },
                            model: {
                              value: _vm.search.endPhysicalDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "endPhysicalDate", $$v)
                              },
                              expression: "search.endPhysicalDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "报名日期", "label-width": 75 } },
                        [
                          _c("DatePicker", {
                            staticStyle: { width: "112px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "起始日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeSignUpStart },
                            model: {
                              value: _vm.search.signUpStartDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "signUpStartDate", $$v)
                              },
                              expression: "search.signUpStartDate",
                            },
                          }),
                          _c("DatePicker", {
                            staticStyle: { width: "112px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "结束日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeSignUpEnd },
                            model: {
                              value: _vm.search.signUpEndDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "signUpEndDate", $$v)
                              },
                              expression: "search.signUpEndDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "来源" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: {
                                width: "100%",
                                "min-width": "90px",
                              },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.sources,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "sources", $$v)
                                },
                                expression: "search.sources",
                              },
                            },
                            _vm._l(_vm.enums.sourcesList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  staticStyle: { width: "100%" },
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("\n                "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "5px",
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { size: "small", icon: "md-add", type: "primary" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "name",
              label: "任务名称",
              "min-width": "350",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "physicalDate",
              label: "预计体检日期",
              "show-overflow-tooltip": "",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "schoolName",
              label: "体检学校",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "signUpStartDate",
              label: "报名开始日期",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "signUpEndDate",
              label: "报名结束日期",
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "signUpNum",
              label: "已报名人数",
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "completedNum",
              label: "已完成人数",
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "source",
              label: "来源",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.enums.sourcesList.filter(
                          (u) => u.value === row.sources
                        )[0].label
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "updateTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "50",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "260",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.signUpNum == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.update(row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.qrCode(row)
                          },
                        },
                      },
                      [_vm._v("二维码")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.download(row)
                          },
                        },
                      },
                      [_vm._v("下载二维码")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.reportGen(row)
                          },
                        },
                      },
                      [_vm._v("报告生成")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.detail(row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            width: "70%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("TaskEdit", {
            ref: "edit",
            style: { "overflow-y": "auto" },
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.showButton
                ? _c(
                    "Button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.editWindow = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  )
                : _vm._e(),
              _vm.showButton
                ? _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("TaskQRCode", { ref: "QRCode" }),
      _c(
        "Modal",
        {
          attrs: {
            width: "50%",
            title: _vm.reportWindowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.reportWindow,
            callback: function ($$v) {
              _vm.reportWindow = $$v
            },
            expression: "reportWindow",
          },
        },
        [
          _c("ReportGen", {
            ref: "report",
            style: { "max-height": _vm.maxHeight, "overflow-y": "auto" },
            on: { "on-submit": _vm.handleReport },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.reportWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.report } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }